import React from 'react';
import { Card, Col, Button, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

const InfoHeader = () => {
  const navigate = useNavigate();
  const handleBack = () => {
    navigate(-1);
  };
  return (
    <Card>
      <Card.Body>
        <Row className="flex-between-center">
          <Col md>
            <h5 className="mb-2 mb-md-0">Инфограффик</h5>
          </Col>
          <Col xs="auto">
            <Button
              variant="link"
              className="text-secondary fw-medium p-0 me-3"
              type="button"
              onClick={handleBack}
            >
              цуцлах
            </Button>
            <Button as={Link} to="/info/new-info" variant="primary" size="sm">
              Шинэ инфо
            </Button>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default InfoHeader;
